import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { getTranslation } from "../../../../../heplers/translationHelper";

export const BuildingInformation = ({ buildingInfo }) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {getTranslation(
              "Building Information",
              "Building Information",
              "Building Information"
            )}
          </Typography>
        }
      />
      <CardContent>
<TableContainer>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Name", "Name", "Name")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Town", "Town", "Town")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Zipcode", "Zipcode", "Zipcode")}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px' }}>
          {getTranslation("Address", "Address", "Address")}
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {buildingInfo?.name}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {buildingInfo?.town}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {buildingInfo?.zipCode}
        </TableCell>
        <TableCell style={{ border: 'none', padding: '8px 16px', fontWeight: 'bold' }}>
          {buildingInfo?.address}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>
      </CardContent>
    </Card>
  );
};
